import _Object$keys from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/object/keys';
import _JSON$stringify from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/core-js/json/stringify';
import _extends from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/extends';
import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// ====== import plugin ======
import axios from '~/plugins/axios';
import domain from '~/plugins/domain';

// ====== import components ======
import LoginForm from '~/components/Login.vue';
import RegisterForm from '~/components/Register.vue';
import ForgetPasswordForm from '~/components/ForgetPassword.vue';

export default {
  components: {
    LoginForm: LoginForm,
    RegisterForm: RegisterForm,
    ForgetPasswordForm: ForgetPasswordForm
  },

  data: function data() {
    return {
      tabIndex: 0
    };
  },
  fetch: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          redirect = _ref.redirect;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (store.state.authUser) {
                _context.next = 4;
                break;
              }

              return _context.abrupt('return', redirect('/'));

            case 4:
              if (!(store.state.authUser.flag === 'tv')) {
                _context.next = 6;
                break;
              }

              return _context.abrupt('return', redirect('/tvCalendar'));

            case 6:
              return _context.abrupt('return', redirect('/mainPage'));

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetch(_x) {
      return _ref2.apply(this, arguments);
    }

    return fetch;
  }(),


  methods: {
    toggleModal: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(userLoginInfo) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.userLoginInfo = userLoginInfo;
                console.log('UserLoginInfo ', userLoginInfo.username);

                if (!this.showConsentModal) {
                  _context2.next = 5;
                  break;
                }

                this.$refs['pdpa-consent'].hide();
                return _context2.abrupt('return');

              case 5:
                this.$refs['pdpa-consent'].show();

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function toggleModal(_x2) {
        return _ref3.apply(this, arguments);
      }

      return toggleModal;
    }(),


    // =================== REGISTER METHOD ===============
    register: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(userRegisterInfo) {
        var tempInfo, infoReturn;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                tempInfo = _extends({}, userRegisterInfo, { flag: 'Con' });
                // const {data} = await axios.post('/domain/User/create', tempInfo);
                // const {data} = await domain.create('User', userRegisterInfo);
                // const {data}  = await axios.post('http://localhost:3003/users/register', tempInfo);

                _context3.next = 3;
                return axios.post('/users/individualRegister', tempInfo);

              case 3:
                infoReturn = _context3.sent.data;

                console.log('this is the userinfo place', infoReturn);

                if (infoReturn.hasOwnProperty('error')) {
                  window.alert(_JSON$stringify(_extends({}, infoReturn.error)));
                } else {
                  alert('Registration request is sent to admin for approval');
                }

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function register(_x3) {
        return _ref4.apply(this, arguments);
      }

      return register;
    }(),


    // =================== LOGIN METHOD =================
    userLogin: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _userLoginInfo, username, password, authUser;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // ===== obtain the user info from log in component =====
                _userLoginInfo = this.userLoginInfo, username = _userLoginInfo.username, password = _userLoginInfo.password;

                console.log('login action', username, password);

                // the consent component will be shown before sent the user infor to backend

                this.acceptPDPA = true;

                // ===== Axios obtains the user from backend =====

                if (!this.acceptPDPA) {
                  _context4.next = 13;
                  break;
                }

                _context4.next = 6;
                return axios.post('/users/login', this.userLoginInfo);

              case 6:
                authUser = _context4.sent.data;


                console.log(authUser);
                console.log('\n\n ====== LandingPage <|-- This is the user =======\n', !!authUser.errors ? authUser.errors.username : authUser, '\n ------------------');
                // ===== Check if store.state.authUser assigned =====
                alert(_Object$keys(authUser).length > 1 ? "Login Successful, Click OK to continue" : authUser.errors['username']);

                // ===== force reload after login =====
                window.location.reload(true);

                _context4.next = 14;
                break;

              case 13:
                console.log('Note Accept PDPA Rule ', username, password);

              case 14:
                this.toggleModal();

              case 15:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function userLogin() {
        return _ref5.apply(this, arguments);
      }

      return userLogin;
    }(),


    // ==================== USER FORGET PASSWORD METHOD ==================
    userForgetPassword: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(userForgetPasswordInfo) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                console.log('this is resetting password action', userForgetPasswordInfo);
                //...

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function userForgetPassword(_x4) {
        return _ref6.apply(this, arguments);
      }

      return userForgetPassword;
    }()
  }
  // head () {
  //   return {
  //     title: 'Users'
  //   }
  // }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/index.vue
// module chunks = 7